import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Utils } from '../../services/utils.service';

@Component({
    selector: 'app-configure-table-columns-modal',
    templateUrl: './configure-table-columns-modal.component.html',
    styleUrls: ['./configure-table-columns-modal.component.scss'],
    standalone: false
})
export class ConfigureTableColumnsModalComponent implements OnInit {

	constructor(
		private dialogRef: MatDialogRef<ConfigureTableColumnsModalComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any
	) {}

	ngOnInit(): void {
		if (this.data.checked) {
			this.data.settingsOptions.forEach((group, idx) => {
				group.child.forEach(c => {
					c.checked = this.data.checked.includes(c.value);
					this.checkParentStatus(idx);
				});
			});
		}
	}

	apply(): void {
		return this.dialogRef.close(
			Utils.to1DArray(this.data.settingsOptions.map(g => g.child)).filter(c => c.checked)
		);
	}

	close(): void {
		this.dialogRef.close();
	}

	selectAll(index: number) {
		this.data.settingsOptions[index].child
			.forEach(c => c.checked = !c.disabled ? this.data.settingsOptions[index].parent.checked : c.checked);
		this.data.settingsOptions[index].parent.indeterminate = this.onIndeterminate(index);
	}

	checkParentStatus(index: number) {
		this.data.settingsOptions[index].parent.indeterminate = this.onIndeterminate(index);
		this.data.settingsOptions[index].parent.checked = this.data.settingsOptions[index].child
			.every(c => c.checked || c.disabled);
	}

	onIndeterminate(index: number): boolean {
		return this.data.settingsOptions[index].child.some(child => child.checked) &&
			!this.data.settingsOptions[index].child.every(child => child.checked || child.disabled);
	}
}